import { Injectable } from '@angular/core';
import {
  Company,
  CompaniesEndpoint,
  Response,
  CompaniesFilter,
} from '@fullyops/legacy/data';
import { Observable } from 'rxjs';
import { UiService } from './ui.service';
import { CompanyInput } from '@fullyops/data/companies/company';

@Injectable({
  providedIn: 'root',
})
export class UiCompaniesService extends UiService<
  Company,
  CompanyInput,
  CompaniesEndpoint
> {
  constructor(protected companiesEndpoint: CompaniesEndpoint) {
    super(companiesEndpoint.createStore(), companiesEndpoint);
  }

  loadAll({ filters }: { filters: CompaniesFilter }) {
    this.service
      .getAll(filters, undefined, this.store$)
      .subscribe({ error: console.error });
  }

  getClients(filters: CompaniesFilter): Observable<Response<Company[]>> {
    return this.service.getAll({
      ...filters,
      type: ['CLIENT', 'BOTH'],
    });
  }

  getSuppliers(filters: CompaniesFilter): Observable<Response<Company[]>> {
    return this.service.getAll({
      ...filters,
      type: ['SUPPLIER', 'BOTH'],
    });
  }
}
